import { KitchenOrder } from "../types";

const roleLabels: Record<string, string> = {
  admin_client: "Responsável",
  guest: "Visitante",
};

export const getClientEnrollmentForOrder = (order: KitchenOrder): string | null => {
  if (order?.enrollment) return order.enrollment;

  const role = order?.client?.role;
  if (role && roleLabels[role]) return roleLabels[role];

  return null;
};
